import {
  driftedRealSize,
  type FaceDefinition,
  type FaceKey,
  measurementFrameOf,
  type ProductMeasurementKind,
  type SizeMm,
} from '@repo/api-contracts';

export type EditAreaFaces = Partial<Record<FaceKey, FaceDefinition>>;

/**
 * 기준 프레임(평면 실측 사본·원통 {π × 지름 / 2, 높이})과 검사 대상 표면 규칙(mesh·실측 종류 불일치 제외)은
 * 계약 하나다 — 서버 저장 검사(EditAreasService)와 같은 함수·같은 GEOMETRY_TOLERANCE 로 같은 double 이 나온다.
 * 호출부 이름을 지키기 위해 그대로 다시 내보낸다.
 */
export { followsMeasurementFrame, measurementFrameOf } from '@repo/api-contracts';

/**
 * 상품 실측 프레임과 다른 첫 표면의 실측을 `FACE_KEYS` 순서로 찾는다. 없으면(또는 상품 실측이 없으면) null.
 * 계약 `driftedRealSize` 에 실측 프레임을 넘기는 어댑터이고, `hasMeasurementDrift`도 이 함수 하나로 판정한다.
 */
export const findDriftedRealSize = (
  faces: EditAreaFaces,
  measurement: SizeMm | null,
  measurementKind: ProductMeasurementKind,
): SizeMm | null =>
  measurement === null
    ? null
    : driftedRealSize(faces, measurementFrameOf(measurementKind, measurement), measurementKind);

/**
 * 표면 실측(faces.<면>.surfaces[].realSize)이 상품 실측 프레임과 다른 것이 하나라도 있는가.
 * 상품 실측이 없으면 별도 안내 대상이라 불일치로 보지 않는다.
 */
export const hasMeasurementDrift = (
  faces: EditAreaFaces,
  measurement: SizeMm | null,
  measurementKind: ProductMeasurementKind,
): boolean => findDriftedRealSize(faces, measurement, measurementKind) !== null;
